module.exports = __webpack_public_path__ + "img/idcard_top.c3cc4aa2.png";